import * as go from 'gojs';
import { IS_SIDEBAR_TYPE_PROP } from '../../common/config/common-prop-names';
import { LinkArchetype } from '../models/link.model';
import { linkTemplate } from './../link';
import {
  adjustInsertLink,
  restoreTemporaryPortStroke,
  setTemporaryPortStroke,
  sidebarLinkingToolIsValidTo,
} from './linking-utils';

export const linkOverrideLinkingTool = (diagram: go.Diagram, category: string) => {
  const linkingTool = diagram.toolManager.linkingTool;

  overrideLinking(category, linkingTool);
};

const overrideLinking = (linkCategory: string, tool: go.LinkingTool) => {
  const originalUnconnectedLinkValid = tool.isUnconnectedLinkValid;
  const insertLinkBase = tool.insertLink.bind(tool);
  const doActivateBase = tool.doActivate.bind(tool);
  const doDeactivateBase = tool.doDeactivate.bind(tool);
  const isValidToBase = tool.isValidTo.bind(tool);

  tool.insertLink = insertLink(linkCategory, tool, insertLinkBase);

  tool.doActivate = () => {
    const originalFromPort = tool.findLinkablePort();
    if (!originalFromPort?.part) {
      return;
    }

    if (originalFromPort.part.data[IS_SIDEBAR_TYPE_PROP]) {
      tool.temporaryLink = linkTemplate();
      tool.isUnconnectedLinkValid = true;
      setTemporaryPortStroke(tool);
    }

    doActivateBase();
  };

  tool.doDeactivate = () => {
    tool.isUnconnectedLinkValid = originalUnconnectedLinkValid;
    doDeactivateBase();
    restoreTemporaryPortStroke(tool);
  };

  tool.isValidTo = isValidTo(tool, isValidToBase);
};

const isValidTo =
  (tool: go.LinkingTool, isValidToBase: (toNode: go.Node, toPort: go.GraphObject) => boolean) =>
  (toNode: go.Node, toPort: go.GraphObject) => {
    if (!tool.originalFromPort?.part?.data[IS_SIDEBAR_TYPE_PROP]) {
      return isValidToBase.call(tool, toNode, toPort);
    }

    return sidebarLinkingToolIsValidTo(tool)(toNode, toPort);
  };

const insertLink =
  (
    linkCategory: string,
    tool: go.LinkingTool,
    insertLinkBase: (
      fromNode: go.Node | null,
      fromPort: go.GraphObject | null,
      toNode: go.Node | null,
      toPort: go.GraphObject | null,
    ) => go.Link | null,
  ) =>
  (
    fromNode: go.Node | null,
    fromPort: go.GraphObject | null,
    toNode: go.Node | null,
    toPort: go.GraphObject | null,
  ) => {
    const originalArchetype = tool.archetypeLinkData;

    if (!!fromNode?.data[IS_SIDEBAR_TYPE_PROP] || !!toNode?.data[IS_SIDEBAR_TYPE_PROP]) {
      tool.archetypeLinkData = new LinkArchetype(linkCategory);
    }

    const link = insertLinkBase(fromNode, fromPort, toNode, toPort);
    if (link) {
      adjustInsertLink(link, fromNode, fromPort, toNode, toPort);
      tool.archetypeLinkData = originalArchetype;
    }

    return link;
  };
